// `error` values the auth host can post back instead of a token, mapped to the message shown on the login
// screen. `null` returns to login silently. Unknown values get GENERIC_AUTH_ERROR_MESSAGE.
export const AUTH_ERROR_MESSAGES = {
  // the user cancelled at the device-limit block screen
  device_limit: null,
  device_update_required: 'auth_web_error_device_update_required',
  device_rate_limited: 'auth_web_error_device_rate_limited',
  device_check_unavailable: 'auth_web_error_generic',
};

export const GENERIC_AUTH_ERROR_MESSAGE = 'auth_web_error_generic';
